import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const JobOfferApplicationsContainer = () => {
    const ApplStatus = "9";
    const Title = "Rejected Applications";
    const Desc = "Displays all applications that have been rejected during the recruitment process. This module provides a centralized view of rejected application records, including applicant details, applied positions, rejection information, and recruitment history for monitoring, reporting, and reference purposes.";
    return (
        <>
        <Breadcrumbs mainTitle="Rejected Applications" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default JobOfferApplicationsContainer;
